export const de_DE_globalTranslations = {
    translation: {
        badges: {
            'mobileService': 'Mobiler Service',
            'smallestDistance': 'Geringste Distanz',
            'earliestAppointment': 'Frühester Termin',
            'bestRating': 'Beste Bewertung',
            'lowestPrice': 'Günstigster Preis',
            'authorizedGarage': 'Vertragswerkstatt',
        },
        homeHints: {
            tesla: 'Bitte setzen Sie sich über die Tesla-App direkt mit einem Tesla-Servicepunkt in Verbindung, um einen Termin zu vereinbaren.',
            MG: 'Für die Marke MG gibt es aktuell keine verfügbaren Werkstätten, bitte wenden Sie sich direkt an eine Vertragswerkstatt von MG.',
            searchTestCenter: 'Prüfstelle suchen',
            mercedesEV: 'Für elektrische Fahrzeuge der Marke Mercedes-Benz wenden Sie sich bitte direkt an eine Vertragswerkstatt von Mercedes-Benz.',
        },
        contactFormMessages: {
            'activeInquiryExistsForNumberplateErrorMessageTitle': 'Sie haben bereits einen Termin',
            'activeInquiryExistsForNumberplateAndServiceErrorMessageTitle': 'Sie haben bereits einen Termin für diesen Service',
            'returnDateNotReachedTitle': 'Rückgabe ist zu früh geplant',
            'returnDateNotReached': "Ihr Fahrzeug ist noch nicht für die Rückgabe freigegeben. <br/> Frühestes  Rückgabedatum: {{returnDate}}",
            'numberplateCorrect': 'Kennzeichen stimmt',
            'numberplateChange': 'Kennzeichen ändern',
            'numberplateNotFoundTitle': 'Kennzeichen nicht gefunden',
            'numberplateNotFoundMessage': "Wir konnten Ihr Fahrzeug nicht im Leasing-Bestand finden. <br/> Bitte prüfen Sie das angegebene Kennzeichen.",
            'slotAlreadyTakenTitle': ' Oh! Da war jemand schneller',
            'nationwideServiceAddressHeadline': 'Wo soll der Service durchgeführt werden?',
            'wheeSizeDisclaimer': 'Bitte teilen Sie uns Ihre Reifengröße mit, um Rückfragen von der Werkstatt zu vermeiden.',
            'registrationDocumentDisclaimer': 'Damit die Werkstatt Ihren gewünschten Service umsetzen kann, benötigt diese zeitnah im Vorfeld ein Bild Ihres Fahrzeugscheins. Bitte schicken Sie dieses Bild an werkstattmeister@repareo.de, wir leiten das gerne an die Werkstatt weiter.',
            'meinautoContractDoesNotProvideServiceErrorMessageTitle': 'Service nicht im Vertrag enthalten',
            'meinautoContractDoesNotProvideServiceErrorMessage': 'Laut ihrem Vertrag haben Sie keine wintertaugliche Bereifung gebucht. Bitte buchen Sie einen anderen Service oder setzten Sie sich mit MeinAuto in Verbindung.',
            'customerAddressNotGivenTitle': 'Bitte geben sie Ihre Adresse an',
            'customerAddressNotGiven': 'Bei gewissen Services ist die Angabe Ihrer Adresse notwendig. Bitte füllen Sie die entsprechenden Felder aus.',
        },
        bookingInformation: {
            'mobileGlassDisclaimer': 'Der mobile Glasservice fährt direkt zu Ihrer gewünschten Adresse, um Autoscheiben innerhalb von 30 Minuten zu reparieren oder in etwa zwei Stunden auszutauschen und dabei auch komplexe Fahrerassistenzsysteme zu kalibrieren. Der Service ist bundesweit verfügbar.',
        },
        filters: {
            'service': 'Service: ',
            'brand': 'Marke: ',
            'vehicleType': 'Fahrzeugart: ',
            'engineType': 'Antriebsart: '
        },
        benefits: {
            'feedbackTitle': 'Feedback'
        },
        listHints: {
            'shownAsNonBookable': 'Bitte kontaktieren Sie die Werkstatt telefonisch zur Terminvereinbarung, da für den Reifenersatz spezifische Informationen zu den Reifen benötigt werden.',
            'availableServicesListItemTitle': 'Verfügbare {{organization}} Services',
            'leasingVehicleReturn': 'Leasingfahrzeug Rückgabe',
            'callBacks': 'Rückrufaktionen',
            'mobileService': ' mobiler Vor-Ort-Service',
            'glasRepair': 'Glasreparatur und Tausch',
            'ourTip': 'Unsere Auswahl',
            'sortedByDistance': 'Alle Werkstätten sortiert nach Distanz',
            'furtherGaragesSortedByDistance': 'Weitere Werkstätten sortiert nach Distanz',
            'collectAndReturnTooltip': 'Hol- & Bringservice bedeutet Ihr Fahrzeug wird geholt und gebracht, sie erhalten keinen Ersatzwagen in der Zeit in der Ihr Fahrzeug in der Werkstatt ist.',
            'replacementVehicleTooltip': 'Zu Ihrem Werkstatttermin steht ein Ersatzwagen bei der Werkstatt zur Verfügung. Sie müssen diesen persönlich vor Ort entgegennehmen und auch wieder bei der Werkstatt zu den Öffnungszeiten abgeben.',
            'checkContract': 'Vertragsbedingungen beachten',
        },
        premiumServices: {
            additionalServices: 'Gewünschte Zusatzservices*',
            additionalServicesNoStar: 'Gewünschte Zusatzservices',
        },
        generalWords: {
            hint: 'Hinweis:',
            back: 'Zurück',
        },
        homeSteps: {
            ayvensLogin: 'Login über MyAyvens',
            whatsYourNumberplate: 'Wie lautet Ihr KFZ-Kennzeichen?',
            mileage: 'Kilometerstand',
            numberplate: 'KFZ-Kennzeichen',
        },
        login: {
            title: 'Anmeldung',
            subtitle: 'Melden Sie sich mit ihrem repareo Account an, um eine Buchung durchzuführen.',
            eMail: 'E-Mail',
            password: 'Passwort',
            signIn: "Jetzt anmelden",
            validations: {
                email: {
                    required: 'Bitte geben Sie Ihre E-Mail Addresse an.',
                    invalid: 'Bitte geben Sie eine gültige E-Mail Addresse an.',
                },
                password: {
                    required: 'Bitte geben Sie Ihr Passwort an.',
                    minLength: 'Das Passwort muss mindestens 8 Zeichen lang sein.',
                },
            }
        },
        vehicleSelector: {
            title: "Für welches Fahrzeug soll gebucht werden?",
            numberPlate: "Kennzeichen",
            searchNumberPlate: "Kennzeichen suchen",
            backToNumberPlateSelection: "Zurück zur Suche",
            isRightVehicle: "Ist dies das richtige Fahrzeug?",
            contractNumber: "Vertragsnummer",
            submit: "Fahrzeug auswählen",
            vehicleSelector: {
                validation: {
                    errors: {
                        error: {
                            "unauthorized": "Sie haben keine Berechtigung",
                            "not_found": "Zu diesem Kennzeichen wurde kein Fahrzeug gefunden",
                            "vehicle_too_heavy": "Das Fahrzeug ist zu schwer. Das Maximalgewicht beträgt 3500 kg",
                            "contract_number_mismatch": "Etwas ist schiefgelaufen",
                            "invalid_request": "Etwas ist schiefgelaufen"
                        }
                    }
                }
            }
        },
        driverDataStep: {
            mandatory: 'Vorgeschriebene Services',
            optional: 'Optionale Services',
            prohibited: 'Nicht verfügbare Services',
            mandatoryHover: 'Diese Services müssen für das Fahrzeug gebucht werden',
            optionalHover: 'Diese Services sind für das Fahrzeug zusätzlich buchbar',
            prohibitedHover: 'Diese Services sind für das Fahrzeug nicht buchbar',
           backToVehicleSelection: 'Zurück zur Fahrzeugauswahl',
        },
        rentalCarOptions: {
            a: 'A (zb. VW Polo, Ford Fiesta)',
            b: 'B (zb. VW Golf, Opel Astra)',
            i: 'I (zb. VW Golf Variant, Ford Focus Turnier)',
        }
    }
}
